var categoryMap;
(function (categoryMap) {
    categoryMap["motori"] = "motori";
    categoryMap["market"] = "market";
    categoryMap["immobili"] = "immobili";
    categoryMap["lavoro"] = "lavoro";
})(categoryMap || (categoryMap = {}));
const categoryOrder = [
    categoryMap.motori,
    categoryMap.market,
    categoryMap.immobili,
    categoryMap.lavoro,
];
const categoryLabel = {
    [categoryMap.motori]: 'Motori',
    [categoryMap.market]: 'Market',
    [categoryMap.immobili]: 'Immobili',
    [categoryMap.lavoro]: 'Lavoro',
};
const categoryHtmlIds = {
    [categoryMap.motori]: 'anchor-motori',
    [categoryMap.market]: 'anchor-market',
    [categoryMap.immobili]: 'anchor-immobili',
    [categoryMap.lavoro]: 'anchor-lavoro',
};
/**
 * Helper, it returns the categoryEnum from the HTML id attr.
 */
const getCategoryFromHtmlId = function (id) {
    const keys = Object.keys(categoryHtmlIds);
    return keys.find((key) => categoryHtmlIds[key] === id);
};

export { categoryHtmlIds, categoryLabel, categoryMap, categoryOrder, getCategoryFromHtmlId };
//# sourceMappingURL=config.js.map
